/**
 * Re-export from shared package for backward compatibility.
 * New code should import from '@packages/shared/utils' directly.
 */
export {
  showErrorModal,
  subscribeErrorModal,
  subscribeRetry,
  beginRetryPhase,
  endRetryPhase,
  fireRetryCallbacks,
  type ShowErrorModalDetails,
} from '@packages/shared/utils';
